module.exports = __webpack_public_path__ + "static/cable-6ebfcf386d69e8ad772f4c15b9374e1f.jpg";